// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.casino-game-card {
  --casino-game-card-border-radius: 1rem;
  width: 100%;
  background-color: var(--white-1000);
  border-radius: var(--casino-game-card-border-radius);
  overflow: hidden;
  cursor: pointer;
}
.casino-game-card .img-box {
  width: 100%;
  border-top-left-radius: var(--casino-game-card-border-radius);
  border-top-right-radius: var(--casino-game-card-border-radius);
  aspect-ratio: 89/121;
  overflow: hidden;
}
.casino-game-card .img-box .game-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.casino-game-card .casino-game-card-body {
  border-bottom-left-radius: var(--casino-game-card-border-radius);
  border-bottom-right-radius: var(--casino-game-card-border-radius);
  display: none;
  padding: 1rem 1.25rem;
}
.casino-game-card .casino-game-card-body .game-name {
  color: var(--outerSpace-1000);
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
@media screen and (max-width: 991.98px) {
  .casino-game-card {
    --casino-game-card-border-radius: 0.5rem;
  }
  .casino-game-card .casino-game-card-body {
    padding: 0.75rem 1rem;
  }
  .casino-game-card .casino-game-card-body .game-name {
    font-size: 1rem;
  }
}
@media screen and (max-width: 767.98px) {
  .casino-game-card {
    --casino-game-card-border-radius: 0.5rem;
  }
  .casino-game-card .casino-game-card-body .game-name {
    font-size: 0.875rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/GamesWeOfferSection/CasinoGameCard/CasinoGameCardStyle.scss"],"names":[],"mappings":"AAAA;EACE,sCAAA;EACA,WAAA;EACA,mCAAA;EACA,oDAAA;EACA,gBAAA;EACA,eAAA;AACF;AACE;EACE,WAAA;EACA,6DAAA;EACA,8DAAA;EACA,oBAAA;EACA,gBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AACN;AAGE;EACE,gEAAA;EACA,iEAAA;EACA,aAAA;EACA,qBAAA;AADJ;AAGI;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AADN;AAKE;EAzCF;IA0CI,wCAAA;EAFF;EAIE;IACE,qBAAA;EAFJ;EAII;IACE,eAAA;EAFN;AACF;AAME;EArDF;IAsDI,wCAAA;EAHF;EAMI;IACE,mBAAA;EAJN;AACF","sourcesContent":[".casino-game-card {\n  --casino-game-card-border-radius: 1rem;\n  width: 100%;\n  background-color: var(--white-1000);\n  border-radius: var(--casino-game-card-border-radius);\n  overflow: hidden;\n  cursor: pointer;\n  \n  .img-box {\n    width: 100%;\n    border-top-left-radius: var(--casino-game-card-border-radius);\n    border-top-right-radius: var(--casino-game-card-border-radius);\n    aspect-ratio: 89/121;\n    overflow: hidden;\n\n    .game-image {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n  \n  .casino-game-card-body {\n    border-bottom-left-radius: var(--casino-game-card-border-radius);\n    border-bottom-right-radius: var(--casino-game-card-border-radius);\n    display: none;\n    padding: 1rem 1.25rem;\n\n    .game-name {\n      color: var(--outerSpace-1000);\n      font-size: 1.25rem;\n      font-weight: 600;\n      line-height: 1.4;\n      text-align: center;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n    }\n  }\n  \n  @media screen and (max-width: 991.98px) {\n    --casino-game-card-border-radius: 0.5rem;\n\n    .casino-game-card-body {\n      padding: 0.75rem 1rem;\n  \n      .game-name {\n        font-size: 1rem;\n      }\n    }\n  }\n \n  @media screen and (max-width: 767.98px) {\n    --casino-game-card-border-radius: 0.5rem;\n\n    .casino-game-card-body {  \n      .game-name {\n        font-size: 0.875rem;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
